import { useState } from "react";

import { ApiError, api } from "../lib/api";

type Props = { onLoggedIn: () => void };

export function LoginPage({ onLoggedIn }: Props) {
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    try {
      await api.login(pw);
      onLoggedIn();
    } catch (e) {
      if (e instanceof ApiError && e.status === 401)
        setErr("wrong password");
      else setErr("login failed — try again");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <form
        onSubmit={submit}
        className="w-full max-w-sm space-y-4 rounded-lg border border-ink-700 bg-ink-900 p-6"
      >
        <div>
          <h1 className="text-xl font-semibold text-slate-50">trader-bot</h1>
          <p className="mt-1 text-sm text-slate-400">
            dashboard sign-in
          </p>
        </div>
        <input
          type="password"
          autoFocus
          autoComplete="current-password"
          value={pw}
          onChange={(e) => setPw(e.target.value)}
          placeholder="READ_TOKEN"
          className="w-full rounded border border-ink-700 bg-ink-800 px-3 py-2 font-mono text-sm text-slate-100 focus:border-accent-info focus:outline-none"
        />
        {err && <div className="text-sm text-accent-err">{err}</div>}
        <button
          type="submit"
          disabled={busy || !pw}
          className="w-full rounded bg-accent-info px-3 py-2 text-sm font-medium text-blue-50 disabled:opacity-50"
        >
          {busy ? "signing in…" : "sign in"}
        </button>
      </form>
    </div>
  );
}
